import AppRouter from "@core/routing/AppRouter";
import { QueryProvider, ThemeProvider } from "@core/providers";
import "./App.css";

const App = () => {
  return (
    <ThemeProvider>
      <QueryProvider>
        <AppRouter />
      </QueryProvider>
    </ThemeProvider>
  );
};

export default App;
